export const WORKBOOK_DASHBOARD_LIST_ENTITY_NAME = 'WorkbookDashboardList';
export const DASHBOARD_ENTITY_NAME = 'Dashboards';
export const WIDGET_DASHBOARD_ENTITY_NAME = 'WidgetDashboard';
